export const quickSearchAutosuggestReducerKey = 'quickSearchAutosuggest';
export const setInputValueType = 'QS_AUTOSUGGEST_SET_INPUT_VALUE_TYPE';
export const setIsLoadingType = 'QS_AUTOSUGGEST_SET_IS_LOADING_TYPE';
export const setSelectedMapType = 'QS_AUTOSUGGEST_SET_SELECTED_MAP_TYPE';
export const addSelectedType = 'QS_AUTOSUGGEST_ADD_SELECTED_TYPE';
export const clearSearchType = 'QS_AUTOSUGGEST_CLEAR_SEARCH_TYPE';

export const CategoryMap = {
  COMPOUND: 'Chemical Names',
  CONCEPT: 'Concepts',
  TARGET: 'Target Names',
};
export const SELECT_WRAP_SYMBOL = '"';

export const STOP_WORDS = [
  'in',
  'on',
  'by',
  'of',
  'with',
  'without',
  'about',
  'from',
  'to',
  'at',
  'via',
  'using',
  'the',
  'and',
  'or',
  'not',
  'proximity',
  'near',
  'next',
  'activities',
  'activity',
  'article',
  'articles',
  'author',
  'authors',
  'bio data',
  'bioactivity',
  'biological activity',
  'biological data',
  'biological effect',
  'biological information',
  'biological properties',
  'compound',
  'compounds',
  'effect',
  'formation',
  'formations',
  'inhibition',
  'inhibitions',
  'inhibitor',
  'inhibitors',
  'item',
  'items',
  'ligand',
  'ligands',
  'literature',
  'make',
  'making',
  'manufacture',
  'material',
  'materials',
  'patent',
  'patents',
  'pharm data',
  'pharmacological data',
  'pharmacological effect',
  'pharmacological information',
  'pharmacological property',
  'pharmacology',
  'potency',
  'potential',
  'prep',
  'preparation',
  'preparations',
  'prepare',
  'prepared',
  'preparing',
  'preps',
  'properties',
  'property',
  'publication',
  'publications',
  'publicise',
  'publicised',
  'publicize',
  'publicized',
  'publish',
  'published by',
  'published',
  'report',
  'reports',
  'review',
  'reviews',
  'substance',
  'substances',
  'synthesis',
  'synthesise',
  'synthesised',
  'synthesising',
  'synthesize',
  'synthesized',
  'synthesizing',
  'total synthesis',
];

export const BLACKLIST_CONCEPT_TAGS = [
  'publish',
  'published',
  'article',
  'articles',
  'publicize',
  'publicized',
  'publicise',
  'publicised',
  'publication',
  'publications',
  'patent',
  'patents',
  'author',
  'authors',
  'published by',
  'literature',
  'report',
  'reports',
  'review',
  'reviews',
  'preparation',
  'preparations',
  'prep',
  'preps',
  'synthesis',
  'formation',
  'formations',
  'manufacture',
  'total synthesis',
  'make',
  'making',
  'synthesize',
  'synthesise',
  'synthesizing',
  'synthesising',
  'preparing',
  'prepare',
  'prepared',
  'synthesised',
  'synthesized',
  'inhibitors',
  'inhibitor',
  'inhibitions',
  'inhibition',
  'ligand',
  'ligands',
  'activity',
  'activities',
  'bioactivity',
  'biological activity',
  'biological effect',
  'bio data',
  'biological data',
  'biological properties',
  'biological information',
  'pharmacological data',
  'pharm data',
  'pharmacological effect',
  'pharmacological property',
  'pharmacological information',
  'pharmacology',
  'compound',
  'compounds',
  'material',
  'materials',
  'substance',
  'substances',
  'item',
  'items',
  'effect',
  'potential',
  'property',
  'properties',
  'potency',
  'allosteric modulator',
  'allosteric modulators',
  'positive allosteric modulator',
  'positive allosteric modulators',
  'PAM',
  'PAMs',
  'negative allosteric modulator',
  'negative allosteric modulators',
  'NAM',
  'NAMs',
  'silent allosteric modulator',
  'silent allosteric modulators',
  'SAM',
  'SAMs',
  'modulator',
  'modulators',
  'modulator drug',
  'modulator drugs',
  'activator',
  'activators',
  'enzyme activators',
  'enzyme activator',
  'activator drug',
  'activator drugs',
  'stimulator',
  'stimulators',
  'stimulator drug',
  'stimulator drugs',
  'enzyme stimulator',
  'enzyme stimulators',
  'irreversible inhibitor',
  'irreversible inhibitors',
  'suicide inhibitor',
  'suicide inhibitors',
  'suicide inactivator',
  'suicide inactivators',
  'mechanism-based inhibitor',
  'mechanism-based inhibitors',
  'mechanism based inhibitor',
  'mechanism based inhibitors',
  'MBI',
  'MBIs',
  'Inactivator',
  'Inactivators',
  'mechanism-based inactivator',
  'mechanism-based inactivators',
  'mechanism based inactivator',
  'mechanism based inactivators',
  'time-dependent inhibitor',
  'time-dependent inhibitors',
  'time dependent inhibitor',
  'time dependent inhibitors',
  'covalent Inhibitor',
  'covalent Inhibitors',
  'blocker',
  'blockers',
  'blocker drug',
  'blocker drugs',
  'channel blocker',
  'channel blockers',
  'ion channel blocker',
  'ion channel blockers',
  'ICB',
  'ICBs',
  'opener',
  'openers ',
  'channel openers',
  'channel openers',
  'ion channel opener',
  'ion channel openers',
  'substrate',
  'substrates',
  'enzyme substrate',
  'enzyme substrates',
  'in vitro',
  'in vitro bioassay',
  'in vitro bioassays',
  'in vitro assay',
  'in vitro assays',
  'cell based assay',
  'cell based assays',
  'in vitro testing',
  'in vitro testings',
  'in vitro bioassay',
  'in vitro bioassays',
  'Efficacy',
  'in vitro efficacy',
  'in vivo ',
  'in vivo bioassay',
  'in vivo bioassays',
  'in vivo assay',
  'in vivo assays',
  'animal model',
  'animal models',
  'animal testing',
  'animal testings',
  'model organism',
  'model organisms',
  'in vivo animal model',
  'in vivo animal models',
  'metabolism',
  'metabolisms',
  'transports',
  'drug metabolism',
  'drug metabolisms',
  'drug transports',
  'transport',
  'drug transport',
  'transport and metabolism',
  'metabolism and transport',
  'drug metabolism and transport',
  'drug transport and metabolism',
  'Pharmacokinetic',
  'PK',
  'ADME',
  'ADME properties ',
  'Pharmacokinetics',
  'Toxicity',
  'Toxicity and safety',
  'Safety',
  'Safety and toxicity',
  'Safety pharmacology',
  'cytotoxicity',
  'chonic toxicity',
  'acute toxicity',
  'cardiotoxicity',
  'hepatoxicity',
  'hepatic toxicity',
  'cardiac toxicity',
  'Toxicity and Safety pharmacology',
  'Safety pharmacology and Toxicity',
  'Synonyms',
  'Acaricidal',
  'Acaricide',
  'adipogenic activity',
  'Adrenergic',
  'adulticidal activity',
  'Adulticide',
  'Aggregant',
  'algicidal',
  'Algaecidal',
  'Alkalosic',
  'Allergenic',
  'Alpha-blockers',
  'Alphablockers',
  'Alpha blockers',
  'Alphablocker',
  'Alpha blocker',
  'Amidolytic',
  'Anabolic',
  'Anaesthesic',
  'Analeptic',
  'Analgesic',
  'Analgesic : NSAID',
  'NSAID',
  'Analgesic: narcotic/opiate',
  'Analgesic: non narcotic',
  'Androgen',
  'Aneugenic',
  'Angiogenic',
  'Anorectic',
  'Antacid',
  'Antalgic',
  'anti trypanocidal',
  'Anti trypanocidal',
  'Anti-trypanocidal',
  'Antiabuse',
  'Anti abuse',
  'Anti-abuse',
  'antiacaricidal',
  'Anti acaricidal',
  'Anti-acaricidal',
  'Antiacidotic',
  'Anti acidotic',
  'Anti-acidotic',
  'Antiacne',
  'Anti acne',
  'Anti-acne',
  'Antiaddictive',
  'Anti addictive',
  'Anti-addictive',
  'Antiadherent',
  'Anti adherent',
  'Anti-adherent',
  'Antiadhesive',
  'Anti adhesive',
  'Anti-adhesive',
  'Antiadipogenic',
  'Anti adipogenic',
  'Anti-adipogenic',
  'Antiadrenalin',
  'Anti adrenalin',
  'Anti-adrenalin',
  'Antiadrenergic',
  'Anti adrenergic',
  'Anti-adrenergic',
  'Antiaflatoxigenic',
  'Anti aflatoxigenic',
  'Anti-aflatoxigenic',
  'Antiaggregant',
  'Anti aggregant',
  'Anti-aggregant',
  'Antiaggressive',
  'Anti aggressive',
  'Anti-aggressive',
  'Antiaging',
  'Anti aging',
  'Anti-aging',
  'Antialbuminuric',
  'Anti albuminuric',
  'Anti-albuminuric',
  'Antialcoholic',
  'Anti alcoholic',
  'Anti-alcoholic',
  'Antialdosterone',
  'Anti aldosterone',
  'Anti-aldosterone',
  'Antialgae',
  'Anti algae',
  'Anti-algae',
  'Antialkalosic',
  'Anti alkalosic',
  'Anti-alkalosic',
  'Antiallergic',
  'Anti allergic',
  'Anti-allergic',
  'Antiallodynic',
  'Anti allodynic',
  'Anti-allodynic',
  'Anti-ALS',
  'Anti-ALS',
  'Anti ALS',
  'Anti-Amyotrophic lateral sclerosis',
  'AntiAmyotrophic lateral sclerosis',
  'Anti Amyotrophic lateral sclerosis',
  'Anti-Alzheimer',
  'Antialzheimer',
  'Anti alzheimer',
  'Antiamastigote',
  'Anti amastigote',
  'Anti-amastigote',
  'Antiamoebic',
  'Anti amoebic',
  'Anti-amoebic',
  'Antiamyloidogenic',
  'Anti amyloidogenic',
  'Anti-amyloidogenic',
  'Antianabolic',
  'Anti anabolic',
  'Anti-anabolic',
  'Antianalgesic',
  'Anti analgesic',
  'Anti-analgesic',
  'Antianaphylactic',
  'Anti anaphylactic',
  'Anti-anaphylactic',
  'Antiandrogen',
  'Anti androgen',
  'Anti-androgen',
  'Antianemic',
  'Anti anemic',
  'Anti-anemic',
  'Antianginal',
  'Anti anginal',
  'Anti-anginal',
  'Antiangiogenic',
  'Anti angiogenic',
  'Anti-angiogenic',
  'Antianorectic',
  'Anti anorectic',
  'Anti-anorectic',
  'Antianoxic',
  'Anti anoxic',
  'Anti-anoxic',
  'Antianthrax',
  'Anti anthrax',
  'Anti-anthrax',
  'anti-anxiolytic activity',
  'Anti anxiolytic',
  'Anti-anxiolytic',
  'Antiaphid',
  'Anti aphid',
  'Anti-aphid',
  'Antiapoptotic',
  'Anti apoptotic',
  'Anti-apoptotic',
  'Antiaromatase',
  'Anti aromatase',
  'Anti-aromatase',
  'Antiarrhytmic',
  'Anti arrhytmic',
  'Anti-arrhytmic',
  'Anti-Arteriosclerosis',
  'Antiarteriosclerosis',
  'Anti arteriosclerosis',
  'Antiarthritic',
  'Anti arthritic',
  'Anti-arthritic',
  'Antiasthmatic',
  'Anti asthmatic',
  'Anti-asthmatic',
  'Antiataxic',
  'Anti ataxic',
  'Anti-ataxic',
  'Anti-Atherogenis',
  'Antiatherogenis',
  'Anti atherogenis',
  'Anti-Atherosclerosis',
  'Antiatherosclerosis',
  'Anti atherosclerosis',
  'Antiatrophic',
  'Anti atrophic',
  'Anti-atrophic',
  'Antibabesia',
  'Anti babesia',
  'Anti-babesia',
  'Antibiofilm',
  'Anti biofilm',
  'Anti-biofilm',
  'Antibiotic',
  'Anti biotic',
  'Anti-biotic',
  'Anti-Botrytis',
  'Antibotrytis',
  'Anti botrytis',
  'Anti-Botulism',
  'Antibotulism',
  'Anti botulism',
  'Antibradycardic',
  'Anti bradycardic',
  'Anti-bradycardic',
  'Antibronchitic',
  'Anti bronchitic',
  'Anti-bronchitic',
  'Antibronchoconstrictive',
  'Anti bronchoconstrictive',
  'Anti-bronchoconstrictive',
  'Anti-BVDV',
  'AntiBVDV',
  'Anti BVDV',
  'anti bovine viral diarrhea virus',
  'antibovine viral diarrhea virus',
  'Anticacilytic',
  'Anti cacilytic',
  'Anti-cacilytic',
  'Anticandidal',
  'Anti candidal',
  'Anti-candidal',
  'Anticarcinogenic',
  'Anti carcinogenic',
  'Anti-carcinogenic',
  'Anticariogenic',
  'Anti cariogenic',
  'Anti-cariogenic',
  'Anticataleptic',
  'Anti cataleptic',
  'Anti-cataleptic',
  'Anti-Cataract',
  'Anticataract',
  'Anti cataract',
  'Anticatatonic',
  'Anti catatonic',
  'Anti-catatonic',
  'Anti-Chagas',
  'Antichagas',
  'Anti chagas',
  'Antichemotactic',
  'Anti chemotactic',
  'Anti-chemotactic',
  'Antichlamydial',
  'Anti chlamydial',
  'Anti-chlamydial',
  'Anti-Cholera',
  'Anticholera',
  'Anti cholera',
  'Anticholesterol',
  'Anti cholesterol',
  'Anti-cholesterol',
  'Anticholinergic',
  'Anti cholinergic',
  'Anti-cholinergic',
  'Anticlastogenic',
  'Anti clastogenic',
  'Anti-clastogenic',
  'Anticoagulant',
  'Anti coagulant',
  'Anti-coagulant',
  'Anticoccidial',
  'Anti coccidial',
  'Anti-coccidial',
  'Anticonvulsant',
  'Anti convulsant',
  'Anti-convulsant',
  'Anticryptosporidial',
  'Anti cryptosporidial',
  'Anti-cryptosporidial',
  'Anti-Cushing',
  'Anticushing',
  'Anti cushing',
  'Anti-Cystic fibrosis',
  'Anticystic fibrosis',
  'Anti cystic fibrosis',
  'Anticystogenetic',
  'Anti cystogenetic',
  'Anti-cystogenetic',
  'Anticytolytic',
  'Anti cytolytic',
  'Anti-cytolytic',
  'Anticytopathic',
  'Anti cytopathic',
  'Anti-cytopathic',
  'Anticytostatic',
  'Anti cytostatic',
  'Anti-cytostatic',
  'Anticytotoxic',
  'Anti cytotoxic',
  'Anti-cytotoxic',
  'Antidandruff',
  'Anti dandruff',
  'Anti-dandruff',
  'Antidegenerative',
  'Anti degenerative',
  'Anti-degenerative',
  'Anti-dementia',
  'Antidementia',
  'Anti dementia',
  'Anti-Dengue',
  'Antidengue',
  'Anti Dengue',
  'Anti-Dengue-2',
  'Antidengue-2',
  'Anti Dengue-2',
  'Antidepressant',
  'Anti depressant',
  'Anti-depressant',
  'Antidermatitic',
  'Anti dermatitic',
  'Anti-dermatitic',
  'Antidermatological',
  'Anti dermatological',
  'Anti-dermatological',
  'Antidiabetic',
  'Anti diabetic',
  'Anti-diabetic',
  'Antidiarrheic',
  'Anti diarrheic',
  'Anti-diarrheic',
  'Antidipsotropic',
  'Anti dipsotropic',
  'Anti-dipsotropic',
  'Antidiuretic',
  'Anti diuretic',
  'Anti-diuretic',
  'Antidopaminergic',
  'Anti dopaminergic',
  'Anti-dopaminergic',
  'Antidote',
  'Anti dote',
  'Anti-dote',
  'Antidyskinetic',
  'Anti dyskinetic',
  'Anti-dyskinetic',
  'Antidyslipidemic',
  'Anti dyslipidemic',
  'Anti-dyslipidemic',
  'Antidysmenorrheic',
  'Anti dysmenorrheic',
  'Anti-dysmenorrheic',
  'Antidyspeptic',
  'Anti dyspeptic',
  'Anti-dyspeptic',
  'Antidystonic',
  'Anti dystonic',
  'Anti-dystonic',
  'Antiedematous',
  'Anti edematous',
  'Anti-edematous',
  'Antiemetic',
  'Anti emetic',
  'Anti-emetic',
  'Antiendotoxic',
  'Anti endotoxic',
  'Anti-endotoxic',
  'Antientamoebal',
  'Anti entamoebal',
  'Anti-entamoebal',
  'Antienterococcal',
  'Anti enterococcal',
  'Anti-enterococcal',
  'Antiestrogen',
  'Anti estrogen',
  'Anti-estrogen',
  'Antiexsudative',
  'Anti exsudative',
  'Anti-exsudative',
  'Antifeedant',
  'Anti feedant',
  'Anti-feedant',
  'Antifertilisation',
  'Anti fertilisation',
  'Anti-fertilisation',
  'Antifertility',
  'Anti fertility',
  'Anti-fertility',
  'Antifibrillic',
  'Anti fibrillic',
  'Anti-fibrillic',
  'Antifibrinolytic',
  'Anti fibrinolytic',
  'Anti-fibrinolytic',
  'Antifibrotic',
  'Anti fibrotic',
  'Anti-fibrotic',
  'Antifilarial',
  'Anti filarial',
  'Anti-filarial',
  'Antiflatulent',
  'Anti flatulent',
  'Anti-flatulent',
  'Antiflaviviral',
  'Anti flaviviral',
  'Anti-flaviviral',
  'Anti-Flu',
  'Antiflu',
  'Anti flu',
  'Antifolic',
  'Anti folic',
  'Anti-folic',
  'Antifouling',
  'Anti fouling',
  'Anti-fouling',
  "Anti-Friedreich's ataxia",
  "AntiFriedreich's ataxia",
  "Anti Friedreich's ataxia",
  'Antifriedreichs ataxia',
  'Anti Friedreichs ataxia',
  'Anti-Friedreich ataxia',
  'Anti-Friedreichs ataxia',
  'Antifriedreich ataxia',
  'Anti Friedreich ataxia',
  'Antifungal',
  'Fungicidal',
  'Anti-Gastritis',
  'Antigastritis',
  'Anti gastritis',
  'Anti-Gaucher',
  'Antigaucher',
  'Anti gaucher',
  'Antigenic',
  'Anti genic',
  'Anti-genic',
  'Antigenotoxic',
  'Anti genotoxic',
  'Anti-genotoxic',
  'Antigermination',
  'Anti germination',
  'Anti-germination',
  'Antigestagenic',
  'Anti gestagenic',
  'Anti-gestagenic',
  'Antigiardial',
  'Anti giardial',
  'Anti-giardial',
  'Antiglaucoma',
  'Anti glaucoma',
  'Anti-glaucoma',
  'Anti-Glioma',
  'Antiglioma',
  'Anti Glioma',
  'Antiglycolytic',
  'Anti glycolytic',
  'Anti-glycolytic',
  'Antigonadotropic',
  'Anti gonadotropic',
  'Anti-gonadotropic',
  'Antigout agent',
  'Anti gout agent',
  'Anti-gout agent',
  'Antihaemorroidal',
  'Anti haemorroidal',
  'Anti-haemorroidal',
  'Anti-Halitosis',
  'Antihalitosis',
  'Anti Halitosis',
  'Anti-HAV',
  'AntiHAV',
  'Anti HAV',
  'Antihepatitis A virus',
  'Anti-hepatitis A virus',
  'Anti hepatitis A virus',
  'Anti-HBV',
  'Anti-HBV',
  'AntiHBV',
  'Antihepatitis B virus',
  'Anti-hepatitis B virus',
  'Anti hepatitis B virus',
  'Anti-HCMV',
  'AntiHCMV',
  'Anti HCMV',
  'Anti-human cytomegalovirus',
  'Anti human cytomegalovirus',
  'Antihuman cytomegalovirus',
  'Anti-HCV',
  'AntiHCV',
  'Anti HCV',
  'Antihepatitis C virus',
  'Anti-hepatitis C virus',
  'Anti hepatitis C virus',
  'Antihelmintic',
  'Anti helmintic',
  'Anti-helmintic',
  'Antihemagglutinative',
  'Anti hemagglutinative',
  'Anti-hemagglutinative',
  'Antihemolytic',
  'Anti hemolytic',
  'Anti-hemolytic',
  'Antihemorrhagic',
  'Anti hemorrhagic',
  'Anti-hemorrhagic',
  'Anti-Hepatitis',
  'AntiHepatitis',
  'Anti Hepatitis',
  'Antihepatocellular',
  'Anti hepatocellular',
  'Anti-hepatocellular',
  'Antihepatotoxic',
  'Anti hepatotoxic',
  'Anti-hepatotoxic',
  'Anti-Herpes',
  'Anti-Herpes',
  'Anti Herpes',
  'Antihidrotic',
  'Anti hidrotic',
  'Anti-hidrotic',
  'Antihistaminic',
  'Anti histaminic',
  'Anti-histaminic',
  'Anti-HIV',
  'AntiHIV',
  'Anti HIV',
  'Anti-human immunodeficiency virus',
  'Anti human immunodeficiency virus',
  'antihuman immunodeficiency virus',
  'Anti-HPV',
  'AntiHPV',
  'Anti HPV',
  'Anti-human papillomavirus',
  'Antihuman papillomavirus',
  'Antihuman papillomavirus',
  'Anti-human papilloma virus',
  'Anti human papilloma virus',
  'Antihuman papilloma virus',
  'Anti-Huanglongbing',
  'Antihuanglongbing',
  'Anti Huanglongbing',
  'Anti-Huntington',
  'Antihuntington',
  'Anti Huntington',
  'Antihyperactive',
  'Anti hyperactive',
  'Anti-hyperactive',
  'Antihyperalgesic',
  'Anti hyperalgesic',
  'Anti-hyperalgesic',
  'Antihypercholesterolemic',
  'Anti hypercholesterolemic',
  'Anti-hypercholesterolemic',
  'Antihyperglycemic',
  'Anti hyperglycemic',
  'Anti-hyperglycemic',
  'Antihyperkinesic',
  'Anti hyperkinesic',
  'Anti-hyperkinesic',
  'Antihyperlipidemic',
  'Anti hyperlipidemic',
  'Anti-hyperlipidemic',
  'Antihypertensive',
  'Anti hypertensive',
  'Anti-hypertensive',
  'Antihypertriglyceridemic',
  'Anti hypertriglyceridemic',
  'Anti-hypertriglyceridemic',
  'Antihypertrophic',
  'Anti hypertrophic',
  'Anti-hypertrophic',
  'Antihyperuricemic',
  'Anti hyperuricemic',
  'Anti-hyperuricemic',
  'Antihyphal',
  'Anti hyphal',
  'Anti-hyphal',
  'Antihypnotic',
  'Anti hypnotic',
  'Anti-hypnotic',
  'Antihypoglycemic',
  'Anti hypoglycemic',
  'Anti-hypoglycemic',
  'Antihypotensive',
  'Anti hypotensive',
  'Anti-hypotensive',
  'Antihypothermic',
  'Anti hypothermic',
  'Anti-hypothermic',
  'Antihypotonic',
  'Anti hypotonic',
  'Anti-hypotonic',
  'Antihypoxic',
  'Anti hypoxic',
  'Anti-hypoxic',
  'Anti-IBD',
  'Anti-IBD',
  'AntiIBD',
  'Anti-inflammatory bowel disease',
  'Antiinflammatory bowel disease',
  'Anti inflammatory bowel disease',
  'Antiinfective',
  'Anti infective',
  'Anti-infective',
  'Antiinflammatory',
  'Anti inflammatory',
  'Anti-inflammatory',
  'Antiinflammatory: non-steroidal',
  'Anti inflammatory: non-steroidal',
  'Anti-inflammatory: non-steroidal',
  'Antiinflammatory: steroidal',
  'Anti inflammatory: steroidal',
  'Anti-inflammatory: steroidal',
  'Anti-Influenza',
  'Anti Influenza',
  'AntiInfluenza',
  'Antiinsomnia',
  'Anti insomnia',
  'Anti-insomnia',
  'Antiinvasive',
  'Anti invasive',
  'Anti-invasive',
  'Antiirritant',
  'Anti irritant',
  'Anti-irritant',
  'Antiischemic',
  'Anti ischemic',
  'Anti-ischemic',
  'Antilacrimal',
  'Anti lacrimal',
  'Anti-lacrimal',
  'Antilactation',
  'Anti lactation',
  'Anti-lactation',
  'Anti-Leishmaniasis',
  'Anti leishmaniasis',
  'Antileishmaniasis',
  'Antileprotic',
  'Anti leprotic',
  'Anti-leprotic',
  'Antileukemic',
  'Anti leukemic',
  'Anti-leukemic',
  'Antilipemic',
  'Anti lipemic',
  'Anti-lipemic',
  'Antilipolytic',
  'Anti lipolytic',
  'Anti-lipolytic',
  'Antilisterial',
  'Anti listerial',
  'Anti-listerial',
  'Antilymphangiogenic',
  'Anti lymphangiogenic',
  'Anti-lymphangiogenic',
  'Antimalarial',
  'Anti malarial',
  'Anti-malarial',
  'antimanic',
  'Anti manic',
  'Anti-manic',
  'Anti-Melanogenesis',
  'AntiMelanogenesis',
  'Anti Melanogenesis',
  'Anti-Melanoma',
  'AntiMelanoma',
  'Anti Melanoma',
  'Anti-Metabolic disorder',
  'AntiMetabolic disorder',
  'Anti Metabolic disorder',
  'Antimetastatic',
  'Anti metastatic',
  'Anti-metastatic',
  'Antimicroalgal',
  'Anti microalgal',
  'Anti-microalgal',
  'Antimicrobacterial',
  'Anti microbacterial',
  'Anti-microbacterial',
  'Antimicrobial',
  'Anti microbial',
  'Anti-microbial',
  'antimicrofilament',
  'Anti microfilament',
  'Anti-microfilament',
  'Antimicrosporidial',
  'Anti microsporidial',
  'Anti-microsporidial',
  'Antimigraine',
  'Anti migraine',
  'Anti-migraine',
  'Antimigratory',
  'Anti migratory',
  'Anti-migratory',
  'Antimitogenic',
  'Anti mitogenic',
  'Anti-mitogenic',
  'Antimitotic',
  'Anti mitotic',
  'Anti-mitotic',
  'Anti-MRSA',
  'AntiMRSA',
  'Anti MRSA',
  'Anti-Methicillin-resistant Staphylococcus aureus',
  'Anti Methicillin-resistant Staphylococcus aureus',
  'Anti-Methicillin-resistant Staphylococcus aureus',
  'AntiMethicillin-resistant Staphylococcus aureus',
  'Anti-MSV',
  'AntiMSV',
  'Anti MSV',
  'Anti-Moloney Sarcoma Virus',
  'AntiMoloney Sarcoma Virus',
  'Anti Moloney Sarcoma Virus',
  'Antimuscarinic',
  'Anti muscarinic',
  'Anti-muscarinic',
  'Antimutagenic',
  'Anti mutagenic',
  'Anti-mutagenic',
  'Anti-Myasthenia',
  'AntiMyasthenia',
  'Anti Myasthenia',
  'Antimycobacterial',
  'Anti mycobacterial',
  'Anti-mycobacterial',
  'antimycoplasmal',
  'Anti mycoplasmic',
  'Anti-mycoplasmic',
  'Anti-Myeloma',
  'AntiMyeloma',
  'Anti Myeloma',
  'Antimyeloproliferative',
  'Anti myeloproliferative',
  'Anti-myeloproliferative',
  'Antimyotonic',
  'Anti myotonic',
  'Anti-myotonic',
  'Anti-Myotonic distrophy',
  'AntiMyotonic distrophy',
  'Anti Myotonic distrophy',
  'Antinecrotic',
  'Anti necrotic',
  'Anti-necrotic',
  'antinematocidal',
  'Anti nematocidal',
  'Anti-nematocidal',
  'Antineoplastic',
  'Anticancer',
  'Antitumor, Antitumoral',
  'Antinephretic',
  'Anti nephretic',
  'Anti-nephretic',
  'Antineurodegenerative',
  'Anti neurodegenerative',
  'Anti-neurodegenerative',
  'Antineuroinflammatory',
  'Anti neuroinflammatory',
  'Anti-neuroinflammatory',
  'Anti-Neurosis',
  'AntiNeurosis',
  'Anti Neurosis',
  'Antineurotoxic',
  'Anti neurotoxic',
  'Anti-neurotoxic',
  'Antineutropenic',
  'Anti neutropenic',
  'Anti-neutropenic',
  'Anti-Niemann-Pick type C',
  'AntiNiemannPick type C',
  'Anti NiemannPick type C',
  'Anti-Norovirus',
  'AntiNorovirus',
  'Anti Norovirus',
  'Antiobesity',
  'Anti obesity',
  'Anti-obesity',
  'Antioncogenic',
  'Anti oncogenic',
  'Anti-oncogenic',
  'Antioomycete',
  'Anti oomycete',
  'Anti-oomycete',
  'Antiopportunisic',
  'Anti opportunisic',
  'Anti-opportunisic',
  'Anti-Osteoarthritis',
  'AntiOsteoarthritis',
  'Anti Osteoarthritis',
  'Antiosteoclastogenic',
  'Anti osteoclastogenic',
  'Anti-osteoclastogenic',
  'Antiosteoporetic',
  'Anti osteoporotic',
  'Anti-osteoporotic',
  'Antioxidant',
  'Anti oxidant',
  'Anti-oxidant',
  'Antioxytocic',
  'Anti oxytocic',
  'Anti-oxytocic',
  'Antiparasitic',
  'Anti parasitic',
  'Anti-parasitic',
  'Antiparkinsonian',
  'Anti parkinsonian',
  'Anti-parkinsonian',
  'Antipathogenic',
  'Anti pathogenic',
  'Anti-pathogenic',
  'Antiperoxidant',
  'Anti peroxidant',
  'Anti-peroxidant',
  'Anti-Pertussis',
  'AntiPertussis',
  'Anti Pertussis',
  'Antiphage',
  'Anti phage',
  'Anti-phage',
  'Antiphytopathogenic',
  'Anti phytopathogenic',
  'Anti-phytopathogenic',
  'Antiphytoviral',
  'Anti phytoviral',
  'Anti-phytoviral',
  'Antiplasminic',
  'Anti plasminic',
  'Anti-plasminic',
  'Antiplasmodic',
  'Anti plasmodic',
  'Anti-plasmodic',
  'Antiplathelmintic',
  'Anti plathelmintic',
  'Anti-plathelmintic',
  'Antipneumococcal',
  'Anti pneumococcal',
  'Anti-pneumococcal',
  'Anti-Pneumocystis',
  'AntiPneumocystis',
  'Anti Pneumocystis',
  'Anti-Pneumonia',
  'AntiPneumonia ',
  'Anti Pneumonia',
  'Anti-Prion',
  'AntiPrion',
  'Anti Prion',
  'Anti-Progeria',
  'AntiProgeria',
  'Anti Progeria',
  'Antiprogestagenic',
  'Anti progestagenic',
  'Anti-progestagenic',
  'antiprogestational',
  'Anti progestational',
  'Anti-progestational',
  'Antiprogestin',
  'Anti progestin',
  'Anti-progestin',
  'Antiproliferative',
  'Anti proliferative',
  'Anti-proliferative',
  'Antipromastigote',
  'Anti promastigote',
  'Anti-promastigote',
  'Antiproteasomal',
  'Anti proteasomal',
  'Anti-proteasomal',
  'Antiproteolytic',
  'Anti proteolytic',
  'Anti-proteolytic',
  'Antiprotozoal',
  'Anti protozoal',
  'Anti-protozoal',
  'Antipruritic',
  'Anti pruritic',
  'Anti-pruritic',
  'Antipseudomonal',
  'Anti pseudomonal',
  'Anti-pseudomonal',
  'Antipsoriatic',
  'Anti psoriatic',
  'Anti-psoriatic',
  'Antipsychotic',
  'Anti psychotic',
  'Anti-psychotic',
  'Antiptotic',
  'Anti ptotic',
  'Anti-ptotic',
  'Anti-Puccinia recondita',
  'AntiPuccinia recondita',
  'Anti Puccinia recondita',
  'Antipyretic',
  'Anti pyretic',
  'Anti-pyretic',
  'Antirachitic',
  'Anti rachitic',
  'Anti-rachitic',
  'Antiradical',
  'Anti radical',
  'Anti-radical',
  'Antiresorptive',
  'Anti resorptive',
  'Anti-resorptive',
  'Antiretroviral',
  'Anti retroviral',
  'Anti-retroviral',
  'Antirheumatic',
  'Anti rheumatic',
  'Anti-rheumatic',
  'Anti-Rhinovirus',
  'AntiRhinovirus',
  'AntiRhinovirus',
  'Antirickettsial',
  'Anti rickettsial',
  'Anti-rickettsial',
  'Anti-RSV',
  'AntiRSV',
  'Anti RSV',
  'Anti-Respiratory Syncytial Virus',
  'AntiRespiratory Syncytial Virus',
  'Anti Respiratory Syncytial Virus',
  'Antisalivation',
  'Anti salivation',
  'Anti-salivation',
  'Antischistosomal',
  'Schistosomicidal',
  'Anti-Schizophrenia',
  'AntiSchizophrenia',
  'Anti Schizophrenia',
  'Antisclerotic',
  'Anti sclerotic',
  'Anti-sclerotic',
  'Antiscrapie',
  'Anti scrapie',
  'Anti-scrapie',
  'Antisecretory',
  'Anti secretory',
  'Anti-secretory',
  'Antiseizure',
  'Anti seizure',
  'Anti-seizure',
  'Antisenescent',
  'Anti senescent',
  'Anti-senescent',
  'Antiseptic',
  'Anti septic',
  'Anti-septic',
  'Antiserotonin',
  'Anti serotonin',
  'Anti-serotonin',
  'Antisickling',
  'Anti sickling',
  'Anti-sickling',
  'Anti-SIV',
  'AntiSIV',
  'Anti SIV',
  'Anti-Simian immunodeficiency virus',
  'Anti Simian immunodeficiency virus',
  'AntiSimian immunodeficiency virus',
  'Antisleeping',
  'Anti sleeping',
  'Anti-sleeping',
  'Antismoking',
  'Anti smoking',
  'Anti-smoking',
  'Antispasmodic',
  'Anti spasmodic',
  'Anti-spasmodic',
  'Antispermatogenic',
  'Anti spermatogenic',
  'Anti-spermatogenic',
  'Antistaphylococcal',
  'Anti staphylococcal',
  'Anti-staphylococcal',
  'Anti-Streptococcus',
  'AntiStreptococcus',
  'Anti Streptococcus',
  'Antistress',
  'Anti stress',
  'Anti-stress',
  'Antitachycardiac',
  'Anti tachycardiac',
  'Anti-tachycardiac',
  'Antiteratogenic',
  'Anti teratogenic',
  'Anti-teratogenic',
  'Antitermitic',
  'Anti termitic',
  'Anti-termitic',
  'Antithigmotactic',
  'Anti thigmotactic',
  'Anti-thigmotactic',
  'Antithrombotic',
  'Anti thrombotic',
  'Anti-thrombotic',
  'Antithyroidic',
  'Anti thyroidic',
  'Anti-thyroidic',
  'Anti-TMV',
  'AntiTMV',
  'Anti TMV',
  'Anti-tobacco mosaic virus ',
  'Anti tobacco mosaic virus',
  'Antitobacco mosaic virus',
  'antitoxic',
  'Anti toxic',
  'Anti-toxic',
  'Antitoxoplasmic',
  'Anti toxoplasmic',
  'Anti-toxoplasmic',
  'Antitremor',
  'Anti tremor',
  'Anti-tremor',
  'Antitremoric',
  'Anti tremoric',
  'Anti-tremoric',
  'Anti-Trichinellosis',
  'AntiTrichinellosis',
  'Anti Trichinellosis',
  'Antitriglyceride',
  'Anti triglyceride',
  'Anti-triglyceride',
  'Antitrypanosomal',
  'Anti trypanosomal',
  'Anti-trypanosomal',
  'Anti-Tuberculosis',
  'AntiTuberculosis',
  'Anti Tuberculosis',
  'Antitubulinic',
  'Anti tubulinic',
  'Anti-tubulinic',
  'Antitussive',
  'Anti tussive',
  'Anti-tussive',
  'Antiulcerative',
  'Anti ulcerative',
  'Anti-ulcerative',
  'Antiuterotonic',
  'Anti uterotonic',
  'Anti-uterotonic',
  'Antiuterotrophic',
  'Anti uterotrophic',
  'Anti-uterotrophic',
  'Anti-Varicella zoster',
  'AntiVaricella zoster',
  'Anti Varicella zoster',
  'Antivaricose',
  'Anti varicose',
  'Anti-varicose',
  'Antivascular',
  'Anti vascular',
  'Anti-vascular',
  'Antivasoconstrictor',
  'Anti vasoconstrictor',
  'Anti-vasoconstrictor',
  'Antivasodilatator',
  'Anti vasodilatator',
  'Anti-vasodilatator',
  'Antivasospastic',
  'Anti vasospastic',
  'Anti-vasospastic',
  'Antivenin',
  'Anti venin',
  'Anti-venin',
  'Anti-Venturia inaequalis',
  'AntiVenturia inaequalis',
  'Anti Venturia inaequalis',
  'Antivibrio',
  'Anti vibrio',
  'Anti-vibrio',
  'Antiviral',
  'Anti viral',
  'Anti-viral',
  'Antivirulence',
  'Anti virulence',
  'Anti-virulence',
  'Anti-VSV',
  'AntiVSV',
  'Anti VSV',
  'Anti-Vesicular stomatitis virus',
  'Anti Vesicular stomatitis virus',
  'AntiVesicular stomatitis virus',
  'Antiwrinkle',
  'Anti wrinkle',
  'Anti-wrinkle',
  'Anxiogenic',
  'Anxiolytic',
  'Aphicidal',
  'Apoptotic',
  'Appetite : Enhancer',
  'Arachnicidal',
  'Arrhythmic',
  'Arrhytmogenic',
  'Arthropocidal',
  'Astringent',
  'Attractant',
  'Bacteriolytic',
  'Bacteriostatic',
  'Bathmotropic : Negagtive',
  'Bathmotropic : Positive',
  'Behavioural Symptoms',
  'Beta-blockers',
  'Betablockers',
  'Beta Blockers',
  'Betablocker',
  'Beta Blocker',
  'Beta-blocker ',
  'Biocidal',
  'Biofilm formation',
  'Blood clotting',
  'Body Weight',
  'Bradycardiac',
  'Bradycardic',
  'Breath depressant',
  'Bronchoconstrictor',
  'Bronchodilatator',
  'Broncholytic',
  'Bronchoprotective',
  'Bronchospasmolytic',
  'Calcemic',
  'Calcium channel blocker',
  'Cancer Chemopreventive',
  'Carcinogenic',
  'Cardiodepressive',
  'Cardiogenic',
  'Cardioprotective',
  'Cardiotonic',
  'Cardiotoxic',
  'Cardiovascular',
  'Catabolic',
  'Cataleptic',
  'Cataleptogenic',
  'Cathartic',
  'Cell Death',
  'Cell Viability',
  'Chemopotentiative',
  'Chemopreventive',
  'Chemoprotective',
  'Chemosensitizer',
  'Chemotactic',
  'Cholekinetic',
  'Choleretic',
  'Cholinergic',
  'Chronobiotic',
  'Chronotropic',
  'Chronotropic : Negative',
  'Chronotropic : Positive',
  'Clastogenic',
  'Clonogenic',
  'Coagulant',
  'Cognitive enhancer',
  'Comedolytic',
  'Contraceptive',
  'Convulsant',
  'Corticosteroid',
  'Corticotrope',
  'Cryoprotective',
  'cytogenetic',
  'Cytogenic',
  'Cytolytic',
  'Cytopathic',
  'Cytopathicity : Protective',
  'Cytopathogenic',
  'Cytoprotective',
  'Cytostatic',
  'Cytotoxic',
  'Death',
  'Decongestant',
  'Depressant',
  'Dermatological',
  'Developmental',
  'Diabetogenic',
  'Diagnostic',
  'Diuretic',
  'Dopaminergic',
  'Dromotropic : Negative',
  'Dromotropic : Positive',
  'Ectoparasiticidal',
  'Embryoprotective',
  'Embryotoxic',
  'Emetic',
  'Estrogen',
  'Excitotoxicity',
  'Fertility',
  'fetotoxicity',
  'Fibrinolytic',
  'Food intake : Reducer',
  'Fugetactic',
  'fumigant',
  'Fungistatic',
  'Fungitoxic',
  'Gametocytocidal',
  'Ganglioplegic',
  'Gastroprokinetic',
  'Gastroprotective',
  'gelatinolytic',
  'Genoprotective',
  'Genotoxic',
  'Germination Effect',
  'Gestagenic',
  'Glandular',
  'Glycemic',
  'Gonadotoxic',
  'Growth Hormone secretagogue',
  'Hair growth',
  'Hallucinogen',
  'Hemagglutinative',
  'Hematinic',
  'Hematological',
  'Hematostatic',
  'Hematotoxic',
  'Hemodynamic',
  'Hemolytic',
  'hemorheological',
  'Hemostatic',
  'Hepatoprotective',
  'Hepatotoxic',
  'Herbicidal',
  'Hormone',
  'Hydrolytic',
  'Hyperalgesic',
  'Hypercalcemic',
  'Hypercholesterolemic',
  'Hyperemic',
  'Hyperglycemic',
  'Hyperlipidemic',
  'Hyperphagic',
  'Hypertensive',
  'Hyperthermic',
  'Hypnogenic',
  'Hypnotic',
  'Hypoalgesic',
  'Hypoazotemic',
  'Hypocalcemic',
  'Hypocholesterolemic',
  'Hypofagic',
  'Hypoinsulinaemic',
  'Hypokalemic',
  'Hypolipidemic',
  'Hypolocomotive',
  'Hypotensive',
  'Hypothalamic hormone',
  'Hypothermic',
  'Hypotonic',
  'Hypotrigliceridemic',
  'Hypouricemic',
  'Immunogenic',
  'Immunomodulator',
  'Immunostimulant',
  'Immunosuppressant',
  'Immunotoxic',
  'Immunotropic',
  'Inflammatory',
  'Antinociception',
  'Anti nociceptive',
  'Anti-nociceptive',
  'Inotropic',
  'Inotropic : Negative',
  'Inotropic : Positive',
  'Insecticidal',
  'Insulinotropic',
  'Intraneuronal blocking agent',
  'Irritant',
  'Keratolytic',
  'Lactation : Enhancer',
  'Larvicidal',
  'Laxative',
  'Lethal',
  'Lipid anablic',
  'lipid peroxidation',
  'Lipogenic',
  'Lipolytic',
  'Local Anaesthesic',
  'luciferase',
  'Luteolytic',
  'Lymphopenia',
  'Memory enhancer',
  'metal chelating',
  'Miotic',
  'Miticidal',
  'Mitochondriotoxic',
  'Mitogenic',
  'Molluscicidal',
  'Mortality',
  'Mosquitocidal',
  'Mucolytic',
  'Mutagenic',
  'Mycobactericidal',
  'Mydriatic',
  'Myeloprotective',
  'Myocontractant',
  'Myorelaxant',
  'Narcotic',
  'Necrosis : Enhancer',
  'Nematocidal',
  'Nephroprotective',
  'Nephrotoxic',
  'Neuractive',
  'Neuritogenic',
  'Neurogenic',
  'Neuroleptic',
  'Neuroprotective',
  'Neuroregulatoric',
  'Neurotoxic',
  'Neurotoxic : Acute',
  'Neurotrophic',
  'Nociceptive',
  'Non Toxic',
  'Nootropic',
  'Odorant',
  'Oncogenic',
  'Oncolytic',
  'Orexigenic',
  'Osteoclastogenic',
  'Osteogenic',
  'Otological',
  'Ototoxic',
  'Ovicidal',
  'Ovulation stimulation',
  'Oxidant',
  'Oxidative Stress',
  'Oxytocic',
  'Paralytic',
  'Parasitic',
  'Parasympatholytic',
  'Pediculicidal',
  'Peristaltic : Stimulant',
  'Pesticidal',
  'Phagocytic',
  'Pheromone activity',
  'Photocytotoxic',
  'Photoprotective',
  'Phototoxic',
  'Phytoprotective',
  'Phytotoxic',
  'Piscicidal',
  'Plant growth',
  'Pneumoprotective',
  'Pneumotoxic',
  'Proarrhythmic',
  'Progestagenic',
  'Progestin',
  'Proliferative',
  'Protective',
  'Proteolytic',
  'Psychoanaleptic',
  'Psychodysleptic',
  'Psychostimulant',
  'Psychotomimetic',
  'Psychotonic',
  'Psychotropic',
  'Pyrogenic',
  'radical scavenging',
  'Radioprotective',
  'radiosensitizing activity',
  'relative antifungal',
  'relative binding affinity',
  'relative inhibitory activity',
  'relative iodinating',
  'relaxation',
  'Renoprotective',
  'Repellent',
  'Reproductive Effect',
  'Resorptive',
  'Rodenticidal',
  'Saluretic',
  'scavenging',
  'Schizonticidal',
  'Secretolytic',
  'Sedative',
  'Sensitizing',
  'Skin irritant',
  'Skin permeable',
  'Skin whitening',
  'Skinprotective',
  'Spasmogenic',
  'Spermicidal',
  'Sporacidal',
  'Sympatholytic',
  'Sympathomimetic',
  'Teratogenic',
  'Termicidal',
  'Thermic',
  'Thermogenic',
  'Thrombolytic',
  'Thrombopoietic',
  'Thrombotic',
  'Thyreostatic',
  'Thyroid hormone',
  'Tikcidal',
  'Tocolytic',
  'Toxic',
  'Toxic : Acute',
  'Toxic : Chronic',
  'Toxic : Subacute',
  'Toxic : Subchronic',
  'Tremorigenic',
  'Tuberculostatic',
  'Tumorigenic',
  'Ulcerogenic',
  'Uricostatic',
  'Uricosuric',
  'Urological',
  'Uterotonic',
  'Uterotrophic',
  'Vascular disruptive',
  'Vasoconstrictor',
  'Vasodilator',
  'Vasopressoric',
  'Vasoprotective',
  'Virustatic',
  'Vitamin D analogue',
  'Wakefullness',
  'Weight gain',
  'Weight loss',
  'Wound healing agent',
];
